import React, { useEffect, useRef, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
  ChartOptions,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { Text } from "../../Kit";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
);

export const options: ChartOptions<"line"> = {
  responsive: true,
  animation: false,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    title: { display: false },
  },
  scales: {
    x: {},
    y: {},
  },
};

export type LineChartProps = {
  data: number[];
  labels: string[];
  height?: string;
};

export const LineChart: React.FC<LineChartProps> = ({ data, labels ,height = "300px"}) => {
  const chartRef = useRef<any>(null);
  const [chartData, setChartData] = useState<any>({
    labels,
    datasets: [
      {
        label: "Data",
        data,
        borderColor: "#c75961ff",
        backgroundColor: "rgba(235, 53, 53, 0.5)",
        fill: true,
        tension: 0.4,
        pointRadius: 3,
      },
    ],
  });

  useEffect(() => {
    const chart = chartRef.current;
    if (!chart) return;

    const ctx = chart.ctx;
    const area = chart.chartArea;
    if (!area) return;

const gradient = ctx.createLinearGradient(0, area.top, 0, area.bottom);
gradient.addColorStop(0, "rgba(248, 161, 161, 0.9)");  // قرمز تیره و غلیظ
gradient.addColorStop(0.7, "rgba(247, 208, 208, 0.5)");  // قرمز روشن‌تر
gradient.addColorStop(1, "rgba(250, 195, 195, 0)");  // خاکستری تیره

    const updatedData = {
      ...chartData,
      datasets: [
        {
          ...chartData.datasets[0],
          backgroundColor: gradient,
        },
      ],
    };

    setChartData(updatedData);
  }, [data, labels]);

  return (
    <Text elementType="div" translatable={false} style={{ height: height }}>
      <Line ref={chartRef} options={options} data={chartData} />
    </Text>
  );
};
